import { createAsyncThunk } from "@reduxjs/toolkit";
import createApi from "../../utils/api";

const fetchAgentRequestHistory = createAsyncThunk(
  "AgentRequestHistory/fetch",
  async (_, { rejectWithValue }) => {
    const api = createApi();
    try {
      const response = await api.get("/getagentrequesthistory");
      return response.data;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  }
);

export { fetchAgentRequestHistory };
